import { makeStyles } from '@material-ui/core';

export const useDadosGeraisUsuarioStyles = makeStyles((theme) => ({
  containerVendedor: {
    display: 'flex',

    [theme.breakpoints.down('sm')]: {
      display: 'block',
      '&>div': {
        marginTop: 16,
      },
    },

    flexDirection: 'row',
    '&>label': {
      minWidth: 208,
    },
  },
  containerNomeVendedor: {
    width: '100%',
  },
}));

export const useRestricoesUsuarioStyles = makeStyles({
  label: {
    color: '#333',
    '&.Mui-focused': {
      color: '#222',
    },
  },
});

export const useRestricoesStyles = makeStyles((theme) => ({
  button: {
    margin: 2,
    width: '12%',
    '&.MuiButton-root': {
      [theme.breakpoints.down('sm')]: {
        minWidth: 24,
        width: '12.5%',
      },
    },
  },
  container1: {
    paddingRight: 16,
    [theme.breakpoints.up('sm')]: {
      borderRight: '1px solid #333333;',
    },
  },
  container2: {
    paddingLeft: 16,
  },
  buttonSend: {
    background: '#43a047',
    border: '1px solid #43a047',
    color: '#fff',
    height: 36,
    borderRadius: 5,
    textTransform: 'capitalize',
    '&:hover': {
      background: '#0f7047',
    },
  },
  containerHorario: {
    display: 'flex',
    paddingLeft: 16,
    paddingRight: 0,
    '&>*': {
      flex: 1,
    },
    '&:first-child': {
      marginRight: 8,
    },
  },
  timePicker: {
    flex: 1,
    '&:first-child': {
      marginRight: 8,
    },
  },
  buttonSendContainer: {
    width: '100%',
    paddingRight: 16,
  },
  collapse: {
    width: '100%',
  },
  fullWidth: {
    width: '100%',
  },
}));
